import React from 'react';
import * as PropTypes from 'prop-types';
import { message } from 'antd';
import copyToClipboard from '../../../../utils/copyToClipboard';

import { SvgIcon } from '../../../svg-icon';
import { Popconfirm } from '../../../popovers';

import {
  DropdownContent,
  DropdownItem,
  DropdownList,
  DropdownAction,
} from '../../../ui-helpers';
import { createLink } from './helpers';
import { theme } from '../../../../styles';
import { ROUTES } from '../../../../routes';

export const RequestDropdown = ({
  _id,
  budget,
  subject,
  contacts,
  onTaskCreate,
  onBudgetCreate,
  onCommentCreate,
  handleRequestUpdate,
  handleRequestDelete,
  onMeetingNoteCreate,
}) => (
  <DropdownContent width={200}>
    <DropdownList>
      <DropdownItem>
        <DropdownAction onClick={() => onMeetingNoteCreate(_id)}>
          <SvgIcon type="plus" />
          Create meeting note
        </DropdownAction>
      </DropdownItem>

      <DropdownItem>
        <DropdownAction onClick={() => onCommentCreate(_id)}>
          <SvgIcon type="addNote" />
          Add comment
        </DropdownAction>
      </DropdownItem>

      <DropdownItem>
        <DropdownAction onClick={() => onBudgetCreate(_id)}>
          <SvgIcon
            width={14}
            type="dollar"
            color={theme.colors.secondaryDark}
          />
          {budget[0] ? 'Change' : 'Add'} budget
        </DropdownAction>
      </DropdownItem>

      <DropdownItem>
        <DropdownAction onClick={() => onTaskCreate(_id)}>
          <SvgIcon type="plus" />
          Add task
        </DropdownAction>
      </DropdownItem>

      <DropdownItem>
        <DropdownAction
          onClick={() =>
            copyToClipboard(
              createLink(subject, contacts, ROUTES.REQUEST, _id),
              () => message.success('Link successfully copied'),
            )
          }
        >
          <span>
            <SvgIcon type="link" width={10} height={10} />
            Share via link
          </span>
        </DropdownAction>
      </DropdownItem>

      <DropdownItem>
        <DropdownAction onClick={() => handleRequestUpdate(_id)}>
          <SvgIcon type="pencil" />
          Edit
        </DropdownAction>
      </DropdownItem>

      <DropdownItem>
        <Popconfirm
          title="Are you sure delete this request?"
          onConfirm={() => handleRequestDelete(_id)}
        >
          <DropdownAction data-popconfirm-stay-open>
            <SvgIcon type="trash" width={14} />
            Delete
          </DropdownAction>
        </Popconfirm>
      </DropdownItem>
    </DropdownList>
  </DropdownContent>
);

RequestDropdown.propTypes = {
  _id: PropTypes.string.isRequired,
  budget: PropTypes.array,
  subject: PropTypes.string,
  contacts: PropTypes.array.isRequired,
  onTaskCreate: PropTypes.func.isRequired,
  onBudgetCreate: PropTypes.func.isRequired,
  onCommentCreate: PropTypes.func.isRequired,
  handleRequestUpdate: PropTypes.func.isRequired,
  handleRequestDelete: PropTypes.func.isRequired,
  onMeetingNoteCreate: PropTypes.func.isRequired,
};

RequestDropdown.defaultProps = {
  subject: '',
  budget: [],
};



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/request-dropdown/index.js